import Arrow from '@chegg-wt/core/components/Icon/Arrow'
import Edit from '@chegg-wt/core/components/Icon/Edit'
import Gear from '@chegg-wt/core/components/Icon/Gear'
import Info from '@chegg-wt/core/components/Icon/Info'
import Move from '@chegg-wt/core/components/Icon/Move'
import Trash from '@chegg-wt/core/components/Icon/Trash'
import styled from 'styled-components'
import React from 'react'

interface ExtraProps {
  className?: string
  size?: string
  color?: string
}

// You can find paths by going here:
// https://material.io/
// Download the SVG, and the path should be contained within

const paths = {
  alphabetical:
    'M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z',
  timer:
    'M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z',
  date:
    'M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z',
  checkmark: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z',
  clear:
    'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z',
  error:
    'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z',
  launch:
    'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z',
  filledCheckmark:
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z',
  plus: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z',
  add:
    'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z',
  edit:
    'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z',
  downArrow: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z',
  rightArrow: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z',
  leftArrow: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z',
  chevronRight: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z',
  sort: 'M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z',
  open:
    'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z',
  delete: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z',
  menu:
    'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
  compare: 'M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z',
  settings:
    'M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34c-.03-.2-.2-.34-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z',
  save:
    'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4l6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7zm-1 7h5.5L14 6.5V12z',
  copy:
    'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z',
  'more horizontal':
    'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
  exclamationPoint:
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 11c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z',
  dropdownArrows:
    'M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z',
  search:
    'M1.27897692e-13,8.45194207 C1.27897692e-13,13.1199016 3.73623398,16.9038841 8.34541862,16.9038841 C12.9546033,16.9038841 16.6908372,13.1199016 16.6908372,8.45194207 C16.6908372,3.78398248 12.9546033,0 8.34541862,0 C3.73623398,0 1.27897692e-13,3.78398248 1.27897692e-13,8.45194207 L1.27897692e-13,8.45194207 L1.27897692e-13,8.45194207 Z M1.98565262,8.46022096 C1.98565262,4.89574093 4.83859914,2.00633419 8.35819829,2.00633419 C11.8777974,2.00633419 14.730744,4.89574093 14.730744,8.46022096 C14.730744,12.024701 11.8777974,14.9141077 8.35819829,14.9141077 C4.83859914,14.9141077 1.98565262,12.024701 1.98565262,8.46022096 Z M17.2999932,19.5284564 C16.5944925,20.1917557 15.4916378,20.1502446 14.8366983,19.4357387 C14.8366983,19.4357387 13.1572562,17.4492892 12.3175352,16.4560644 C12.2067205,16.3249925 11.9850913,16.0628487 11.9850913,16.0628487 C11.9850913,16.0628487 12.7670319,15.6752298 13.4421633,15.1434706 C14.1172947,14.6117113 14.7247832,13.9029172 14.7247832,13.9029172 L17.3915423,17.0337193 C18.0464818,17.7482253 18.0054938,18.8651571 17.2999932,19.5284564 Z',
}

interface IconProps {
  name: string
  title?: string
  svgPath?: string
  size?: string
  color?: string
  viewBox?: string
  onClick?: () => any
  className?: string
  hoverColor?: string
  noHover?: boolean
}

export interface IconBaseProps {
  color?: string
  size?: string
  hoverColor?: string
  noHover?: boolean
}

export const IconBase = styled.svg<IconBaseProps>`
  width: ${(props) => props.size || '24px'};
  height: ${(props) => props.size || '24px'};
  margin: 0 ${(props) => props.theme.spacing.xs};
  fill: ${(props) =>
    props.color
      ? props.theme.Colors[props.color] || props.theme.colors[props.color]
      : 'currentColor'};
  box-sizing: unset;
  vertical-align: middle;
  border-style: none;
  &:hover {
    fill: ${(props) =>
      !props.noHover &&
      (props.hoverColor ? props.theme.colors[props.hoverColor] : 'currentColor')};
  }
`
/* tslint:disable trailing-comma */

const Icon: React.FunctionComponent<IconProps> = ({
  name,
  svgPath,
  title,
  className = '',
  noHover = false,
  ...props
}) => (
  <IconBase
    role="img"
    viewBox="0 0 24 28"
    {...props}
    className={className}
    noHover={noHover}
  >
    <title id={title || name}>{title || name}</title>
    <path d={svgPath || paths[name]} />
    <path d="M0 0h24v24H0z" fill="none" />
  </IconBase>
)

/* tslint:disable function-name */
function IconHelper(name, props: ExtraProps = {}, svgPath) {
  const classesFromProps = props.className ? `${props.className} ` : ''
  const className = `${classesFromProps}material-icons icon-${name}`
  return Icon({ name, svgPath, ...props, className })
}

export function IconDone(props: ExtraProps) {
  return IconHelper('done', props, 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z')
}

export function IconError(props: ExtraProps) {
  return IconHelper(
    'error',
    props,
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z'
  )
}

export default Icon

export { Move, Trash, Edit, Gear, Arrow, Info }
